<!--
Global Component
Check system permissions

** Resources:
Access Requests            Interactions
Attributes                 Logs
Blockrules                 Loops
Categories                 Milestones
Credits                    Organizations
Customer Notes             SSO
Customers                  Segments
Dashboards                 Surveys
Distributions              Teams
Domain Authentication      User Invites
IPs                        Users
Widgets                    Message Templates

** Permissions:
Create
Read
Update
Remove
Access
-->
<script>
import { mapActions } from "vuex";

export default {
  name: "permission-control",
  props: {
    resourceName: String,
    permission: String,
    disable: Boolean
  },
  data() {
    return {
      hasPermission: null
    };
  },
  methods: {
    ...mapActions({
      userHasPermission: "team/userHasPermission"
    }),
    async checkPermission() {
      this.hasPermission = await this.userHasPermission({
        resourceName: this.resourceName,
        permissionName: this.permission
      });
    }
  },
  render() {
    if (this.hasPermission === null) {
      //Wait until checkPermission finish
      return;
    }
    // Has permission, return the component
    if (this.hasPermission) {
      return this.$slots.default[0];
    } else if (this.disable) {
      this.$slots.default[0].componentOptions.propsData.disable = true;
      this.$slots.default[0].componentOptions.propsData.disabled = true;
      return this.$slots.default[0];
    }
    // User has permission for nothing! Let's don't show him anything!
    return null;
  },
  created() {
    this.checkPermission();
  }
};
</script>
